var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group list-group-flush "},_vm._l((_vm.prescriptions),function(prescription,index){return _c('li',{key:prescription.id,staticClass:"list-group-item cursor-pointer min-h-4",class:{
      'border-top': index === 0,
      'border-left-0 border-right-0 primary-border-right':
        prescription.id === _vm.prescriptionId,
    }},[_c('prescription-list-item',{attrs:{"prescription":prescription,"filterParams":_vm.filterParams}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }